module.exports = __webpack_public_path__ + "static/media/1007.e2ec974f.jpg";